import React from 'react';
import { FiInstagram, FiTwitter, FiFacebook, FiMail } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-black text-white border-t-8 border-hcf-pink mt-20 pt-16 pb-8 relative overflow-hidden">
      {/* Decorative gradient line */}
      <div className="absolute top-0 left-0 w-full h-2 bg-hcf-gradient"></div>
      
      {/* Halftone Overlay */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/halftone.png')] opacity-10 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-12 relative z-10">
        
        {/* Brand Column */}
        <div className="md:col-span-1">
          <h3 className="font-comic text-5xl text-hcf-yellow mb-4 drop-shadow-[2px_2px_0_#EC008C]">HCF</h3>
          <p className="font-body text-lg text-gray-300 leading-tight">
            Independent. Community-driven. <br/>
            Founded 2015 by <br/>
            <span className="text-hcf-cyan">Chris & Jake</span>.
          </p>
        </div>

        {/* Links Column */}
        <div className="md:col-span-1">
          <h3 className="font-comic text-2xl text-hcf-cyan mb-6 border-b-2 border-hcf-cyan w-fit">Navigation</h3>
          <ul className="space-y-3 font-body text-lg">
            <li><a href="#" className="hover:text-hcf-pink flex items-center gap-2 transition-colors"><span>★</span> Home</a></li>
            <li><a href="#" className="hover:text-hcf-pink flex items-center gap-2 transition-colors"><span>★</span> Line Up</a></li>
            <li><a href="#" className="hover:text-hcf-pink flex items-center gap-2 transition-colors"><span>★</span> Venues</a></li>
            <li><a href="#" className="hover:text-hcf-pink flex items-center gap-2 transition-colors"><span>★</span> Contact</a></li>
          </ul>
        </div>

        {/* Contact Column */}
        <div className="md:col-span-1">
          <h3 className="font-comic text-2xl text-hcf-pink mb-6 border-b-2 border-hcf-pink w-fit">Get In Touch</h3>
          <div className="flex items-center gap-3 mb-4 group cursor-pointer">
            <div className="bg-hcf-pink p-2 group-hover:bg-white transition-colors">
              <SafeIcon icon={FiMail} className="text-black" />
            </div>
            <span className="font-body text-sm break-all group-hover:text-hcf-pink transition-colors">
              Hastingscomedyfestival@yahoo.com
            </span>
          </div>
          <p className="font-body text-sm text-gray-400">
            Hastings & St Leonards<br/>East Sussex, UK
          </p>
        </div>

        {/* Social Column */}
        <div className="md:col-span-1">
          <h3 className="font-comic text-2xl text-white mb-6">Join the Chaos</h3>
          <div className="flex gap-4 mb-8">
            {[FiInstagram, FiTwitter, FiFacebook].map((icon, i) => (
              <a key={i} href="#" className="bg-hcf-yellow text-black p-3 hover:bg-white hover:-translate-y-2 border-2 border-black transition-all shadow-[4px_4px_0_#00AEEF]">
                <SafeIcon icon={icon} className="text-2xl" />
              </a>
            ))}
          </div>
          <p className="font-comic text-hcf-cyan text-sm tracking-widest">
            JUNE 2026 • HCF
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-16 pt-8 border-t border-white/10 text-center">
        <p className="font-body text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} Hastings Comedy Festival. All rights reserved. 
          <br/>
          Designed for laughter by Chris & Jake.
        </p>
      </div>
    </footer>
  );
};

export default Footer;